import { gql } from '@apollo/client'

export const GET_DEPARTMENTS = gql`
  query GetDepartments {
    departments {
      department_id
      name
      description
    }
  }
`
